import React from 'react';
import PropTypes from 'prop-types';
// @fountain/ui-kit's Pagination emits `data-testid="pagination-prev"` /
// `pagination-next` on its Prev/Next anchors. FAUT's JobsDirectoryPage binds
// its `next_page_link` to `testid: 'pagination-next'`, so keep this
// component's ui-kit consumption (or any replacement) exposing those handles
// — otherwise the pagination-driven jobs-directory acceptance spec breaks.
import Pagination from '@fountain/ui-kit/components/pagination';

import './styles.pcss';

function OpeningsDirectoryIndexPagination({ pagination, updateParams }) {
  if (!pagination.totalPages || pagination.totalPages <= 1) {
    return null;
  }

  return (
    <Pagination
      className="openings-directory-index-pagination"
      onChange={page => updateParams({ page })}
      pagination={pagination}
    />
  );
}

OpeningsDirectoryIndexPagination.propTypes = {
  pagination: PropTypes.shape({
    currentPage: PropTypes.number,
    nextPage: PropTypes.number,
    perPage: PropTypes.number,
    totalCount: PropTypes.number,
    totalPages: PropTypes.number,
  }).isRequired,
  updateParams: PropTypes.func.isRequired,
};

export default OpeningsDirectoryIndexPagination;
